<template>
  <div class="min-h-screen bg-white relative">
    <header class="px-4 py-6 md:px-6 lg:px-8 border-b border-gray-100">
      <div class="flex items-center justify-between max-w-7xl mx-auto">
      <div class="flex items-center gap-2">
        <Newlogo/>
      </div>
      <nav class="flex items-center gap-6">
        <a href="/login" class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border bg-background hover:text-accent-foreground h-10 px-4 py-2 border-[#FF4438] text-[#FF4438] hover:bg-[#FF4438]/10">
          Iniciar Sesión
        </a>
      </nav>
      </div>
    </header>
    <section class="px-4 py-16 md:px-6 lg:px-8 bg-gradient-to-br from-[#FF4438]/5 to-[#FDBD50]/5">
      <div class="max-w-7xl mx-auto">
        <div class="text-center max-w-4xl mx-auto animate-fade-in">
          <div class="inline-flex items-center gap-2 bg-[#FDBD50]/10 px-4 py-2 rounded-full text-[#FF4438] font-medium mb-6">
            <i class="icon-energy"></i>
            <span>{{ colavs }} Colaboraciones exitosas</span>
          </div>
          <h1 class="text-5xl md:text-5xl font-bold text-[#1D252C] mb-6 leading-tight">Creadores de contenido para tu restaurante</h1>
          <p class="text-xl md:text-2xl text-gray-600 mb-10 max-w-3xl mx-auto leading-relaxed" style="font-weight: 100;">Solofoodies te conecta con creadores locales e internacionales listos para colaborar y generar contenido. Comienza seleccionando tu tipo de perfil.</p>
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/register/1" class="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 bg-[#FF4438] hover:bg-[#FF4438]/90 text-white px-8 py-4 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-200">
              Foodie
            </a>
            <a href="/register/2" class="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border bg-background hover:text-accent-foreground h-10 border-[#FDBD50] text-[#FF4438] hover:bg-[#FDBD50]/10 px-8 py-4 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-200">
              Restaurante
            </a>
          </div>
        </div>
      </div>
    </section>

    <section class="px-4 py-12 md:px-6 lg:px-8 bg-white border-b border-gray-100">
      <div class="max-w-7xl mx-auto">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div class="text-center">
            <div class="w-12 h-12 bg-[#FF4438]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i class="icon-heartEmpty i24 text-[#FF4438]"></i>
            </div>
            <div class="text-3xl font-bold text-[#1D252C] mb-1">{{ colavs }}</div>
            <div class="text-sm text-gray-600">Colaboraciones Exitosas</div>
          </div>
          <div class="text-center">
            <div class="w-12 h-12 bg-[#FF4438]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i class="icon-forks i24 text-[#FF4438]"></i>
            </div>
            <div class="text-3xl font-bold text-[#1D252C] mb-1">{{ restaurants }}+</div>
            <div class="text-sm text-gray-600">Restaurantes</div>
          </div>
          <div class="text-center">
            <div class="w-12 h-12 bg-[#FF4438]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i class="icon-camera i24 text-[#FF4438]"></i>
            </div>
            <div class="text-3xl font-bold text-[#1D252C] mb-1">{{ foodies }}+</div>
            <div class="text-sm text-gray-600">Creadores</div>
          </div>
          <div class="text-center">
            <div class="w-12 h-12 bg-[#FF4438]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i class="icon-globe i24 text-[#FF4438]"></i>
            </div>
            <div class="text-3xl font-bold text-[#1D252C] mb-1">{{ cities }}+</div>
            <div class="text-sm text-gray-600">Ciudades</div>
          </div>
        </div>
      </div>
    </section>

    <section ref="why-us" class="px-4 py-20 md:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto">
        <div class="text-center max-w-4xl mx-auto">
          <h2 class="text-4xl md:text-5xl font-bold text-[#1D252C] mb-8">¿Por qué Solofoodies?</h2>
          <p class="text-xl md:text-2xl text-gray-600 leading-relaxed mb-12">
            Nuestra misión es facilitar al máximo las colaboraciones entre restaurantes y creadores gastronómicos. Queremos ayudarte a generar visibilidad, compartir experiencias auténticas y celebrar la cultura culinaria. Creemos en conexiones reales que benefician al ecosistema gastronómico</p>
          <div class="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div class="w-16 h-16 bg-[#FF4438]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i class="icon-bagde text-2xl text-[#FF4438]"></i>
              </div>
              <h3 class="text-xl font-bold text-[#1D252C] mb-2">Calidad ante todo</h3>
              <p class="text-gray-600">Colaboraciones curadas que aportan valor real a ambas partes.</p>
            </div>
            <div>
              <div class="w-16 h-16 bg-[#FF4438]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i class="icon-chat text-2xl text-[#FF4438]"></i>
              </div>
              <h3 class="text-xl font-bold text-[#1D252C] mb-2">Impulsado por la comunidad</h3>
              <p class="text-gray-600">Creado por y para quienes viven la cultura gastronómica.</p>
            </div>
            <div>
              <div class="w-16 h-16 bg-[#FF4438]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i class="icon-heartEmpty text-2xl text-[#FF4438]"></i>
              </div>
              <h3 class="text-xl font-bold text-[#1D252C] mb-2">Conexiones auténticas</h3>
              <p class="text-gray-600">Relaciones reales que van más allá de una simple publicación.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section ref="how-it-works" class="px-4 py-20 md:px-6 lg:px-8 bg-[#F9F9F9]">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-16">
          <h2 class="text-4xl md:text-5xl font-bold text-[#1D252C] mb-6">¿Cómo funciona Solofoodies?</h2>
          <p class="text-xl text-gray-600 max-w-2xl mx-auto">Una plataforma diseñada para facilitar colaboraciones auténticas entre restaurantes y creadores de contenido.</p>
        </div>
        <div class="grid md:grid-cols-3 gap-8">
          <div class="rounded-lg bg-card text-card-foreground group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-0 shadow-lg">
            <div class="p-8 text-center">
              <div class="w-16 h-16 bg-[#FF4438]/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#FF4438]/20 transition-colors">
                <i class="icon-search text-2xl text-[#FF4438]"></i>
              </div>
              <h3 class="font-bold text-[#1D252C] mb-4 text-lg">Crea tu perfil</h3>
              <p class="text-gray-600 leading-relaxed">Diseña un perfil atractivo que represente tu restaurante o estilo como creador.</p>
            </div>
          </div>

          <div class="rounded-lg bg-card text-card-foreground group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-0 shadow-lg">
            <div class="p-8 text-center">
              <div class="w-16 h-16 bg-[#FF4438]/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#FF4438]/20 transition-colors">
                <i class="icon-heartEmpty text-2xl text-[#FF4438]"></i>
              </div>
              <h3 class="font-bold text-[#1D252C] mb-4 text-lg">Descubre colaboraciones</h3>
              <p class="text-gray-600 leading-relaxed">Encuentra socios ideales con nuestro directorio de influencers gastronómicos.</p>
            </div>
          </div>

          <div class="rounded-lg bg-card text-card-foreground group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-0 shadow-lg">
            <div class="p-8 text-center">
              <div class="w-16 h-16 bg-[#FF4438]/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#FF4438]/20 transition-colors">
                <i class="icon-graphic text-2xl text-[#FF4438]"></i>
              </div>
              <h3 class="font-bold text-[#1D252C] mb-4 text-lg">Llega a más clientes</h3>
              <p class="text-gray-600 leading-relaxed">Haz crecer tu audiencia y tu marca con colaboraciones auténticas y efectivas.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section ref="history" class="px-4 py-20 md:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-16">
          <h2 class="text-4xl md:text-5xl font-bold text-[#1D252C] mb-6">Lo que dice nuestra comunidad</h2>
          <p class="text-xl text-gray-600">Historias reales de restaurantes y creadores que han encontrado el éxito con Solofoodies</p>
        </div>
        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div v-for="testimonial in testimonials" :key="testimonial" class="rounded-lg bg-card text-card-foreground border-0 shadow-lg hover:shadow-xl transition-all duration-300">
            <div class="p-6">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-[#FF4438] rounded-full flex items-center justify-center text-white font-bold text-sm">{{testimonial.img}}</div>
                <div class="ml-3">
                  <p class="font-semibold text-[#1D252C]">{{testimonial.autor}}</p>
                  <p class="text-sm text-gray-600">{{testimonial.carge}}</p>
                </div>
              </div>
              <p class="text-gray-700 italic text-left">{{testimonial.body}}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section ref="features" class="px-4 py-20 md:px-6 lg:px-8 bg-[#F9F9F9]">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-16">
          <h2 class="text-4xl md:text-5xl font-bold text-[#1D252C] mb-6">¿Para quién es Solofoodies?</h2>
        </div>
        <div class="grid md:grid-cols-3 gap-8">
          <div class="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <div class="text-center mb-8">
              <div class="w-16 h-16 bg-[#FDBD50]/10 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i class="icon-camera text-2xl text-[#FDBD50]"></i>
              </div>
              <h3 class="text-2xl md:text-2xl font-bold text-[#1D252C] mb-4">Creadores</h3>
            </div>
            <div class="space-y-4 text-left">
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#FDBD50]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Explora colaboraciones según tu ubicación actual</h4>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#FDBD50]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Añade viajes próximos con ubicación y fechas</h4>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#FDBD50]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Aplica a colaboraciones antes de llegar a nuevas ciudades</h4>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#FDBD50]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Rastrea el estado de tus colaboraciones y chatea con restaurantes</h4>
                </div>
              </div>
            </div>
          </div>

          <div class="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <div class="text-center mb-8">
              <div class="w-16 h-16 bg-[#FF4438]/10 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i class="icon-forks text-2xl text-[#FF4438]"></i>
              </div>
              <h3 class="text-2xl md:text-2xl font-bold text-[#1D252C] mb-4">Restaurantes</h3>
            </div>
            <div class="space-y-4 text-left">
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#FF4438]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Crea colaboraciones públicas en menos de 1 minuto</h4>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#FF4438]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Recibe solicitudes de creadores locales e internacionales</h4>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#FF4438]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Habla directo con creadores y define expectativas desde el chat integrado</h4>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#FF4438]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Valora a los creadores al finalizar la colaboración</h4>
                </div>
              </div>
            </div>
          </div>

          <div class="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <div class="text-center mb-8">
              <div class="w-16 h-16 bg-[#10B981]/10 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i class="icon-edifice text-2xl text-[#10B981]"></i>
              </div>
              <h3 class="text-2xl md:text-2xl font-bold text-[#1D252C] mb-4 ">Agencias de Marketing</h3>
            </div>
            <div class="space-y-4 text-left">
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Gestiona múltiples restaurantes desde un solo perfil</h4>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Maneja restaurantes con múltiples ubicaciones</h4>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Dashboard centralizado para todas las colaboraciones</h4>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                <div>
                  <h4 class="font-semibold text-[#1D252C] text-sm">Analíticas consolidadas por cliente</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section ref="pricing" class="px-4 py-20 md:px-6 lg:px-8 bg-white">
      <div class="max-w-6xl mx-auto">
        <div class="text-center mb-16">
          <h2 class="text-4xl md:text-5xl font-bold text-[#1D252C] mb-6">Planes y Precios</h2>
          <p class="text-xl text-gray-600 max-w-2xl mx-auto">Los creadores empiezan gratis, los restaurantes acceden a todas las funcionalidades con planes mensuales.</p>
        </div>
        <div class="flex justify-center mb-12 md:hidden">
          <div class="bg-gray-100 p-1 rounded-lg">
            <button :class="responsiveTap == 'mensual' ? 'bg-white' : ''" class="px-6 py-2 rounded-md font-medium transition-colors  text-[#1D252C] shadow-sm" @click="toogleResponsiveTap('mensual')">Mensual</button>
            <button :class="responsiveTap == 'anual' ? 'bg-white' : ''" class="px-6 py-2 rounded-md font-medium transition-colors text-gray-600 hover:text-[#1D252C]" @click="toogleResponsiveTap('anual')">Pago único</button>
          </div>
        </div>
        <div class="md:hidden max-w-md mx-auto">
          <div v-if="responsiveTap =='mensual'" class="rounded-lg bg-card text-card-foreground shadow-sm border-2 border-[#FF4438] relative overflow-hidden">
            <div class="absolute top-0 left-1/2 transform -translate-x-1/2 bg-[#FF4438] text-white px-4 py-1 rounded-b-lg text-sm font-medium">
              Más Popular
            </div>
            <div class="p-8 pt-12">
              <div class="text-center mb-8">
                <h3 class="text-2xl font-bold text-[#1D252C] mb-2">Plan Mensual</h3>
                <p class="text-gray-600 mb-6">Para restaurantes independientes, grupos y agencias</p>
                <div class="mb-4">
                  <div class="flex items-center justify-center gap-1">
                    <span class="text-5xl font-bold text-[#1D252C]">&euro; 29</span>
                    <span class="text-xl text-gray-600">/mes</span>
                  </div>
                  <p class="text-sm text-gray-600 mt-2">Primer restaurante incluido</p>
                  <p class="text-sm text-green-500 font-medium mt-1">+€29/mes por cada restaurante adicional</p>
                </div>
              </div>
              <div class="space-y-4 mb-8">
                <div class="flex items-center gap-3">
                  <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                  <span class="text-gray-700 text-left">Colaboraciones públicas ilimitadas</span>
                </div>
                <div class="flex items-center gap-3">
                  <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                  <span class="text-gray-700">Chat ilimitado</span>
                </div>
                <div class="flex items-center gap-3">
                  <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                  <span class="text-gray-700">Analíticas básicas</span>
                </div>
                <div class="flex items-center gap-3">
                  <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                  <span class="text-gray-700 text-left">Gestión de múltiples restaurantes</span>
                </div>
              </div>
              <a href="/register/2" class="text-lg inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 px-4 w-full bg-[#FF4438] hover:bg-[#FF4438]/90 text-white font-semibold py-3">
                Comenzar
              </a>
            </div>
          </div>

          <div v-if="responsiveTap =='anual'" class="rounded-lg bg-card text-card-foreground shadow-sm border-2 border-[#FDBD50] relative overflow-hidden">
            <div class="absolute top-0 left-1/2 transform -translate-x-1/2 bg-[#FDBD50] text-white px-4 py-1 rounded-b-lg text-sm font-medium">
              Mejor Valor
            </div>
            <div class="p-8 pt-12">
              <div class="text-center mb-8">
                <h3 class="text-2xl font-bold text-[#1D252C] mb-2">Pago Único</h3>
                <p class="text-gray-600 mb-6">Para restaurantes independientes, grupos y agencias</p>
                <div class="mb-4">
                  <div class="flex items-center justify-center gap-1">
                    <span class="text-5xl font-bold text-[#1D252C]">&euro; 232</span>
                  </div>
                  <p class="text-sm text-gray-600 mt-2">Primer restaurante incluido</p>
                  <p class="text-sm text-green-500 font-medium mt-1">+&euro;232 por cada restaurante adicional</p>
                </div>
              </div>
              <div class="space-y-4 mb-8">
                <div class="flex items-center gap-3">
                  <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                  <span class="text-gray-700 text-left">Colaboraciones públicas ilimitadas</span>
                </div>
                <div class="flex items-center gap-3">
                  <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                  <span class="text-gray-700">Chat ilimitado</span>
                </div>
                <div class="flex items-center gap-3">
                  <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                  <span class="text-gray-700">Analíticas básicas</span>
                </div>
                <div class="flex items-center gap-3">
                  <i class="icon-checkCircle text-xl text-[#10B981]"></i>
                  <span class="text-gray-700 text-left">Gestión de múltiples restaurantes</span>
                </div>
              </div>
              <a href="/register/2" class="text-lg inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 px-4 w-full bg-[#FDBD50] hover:bg-[#FDBD50]/90 text-white font-semibold py-3">
                Comenzar
              </a>
            </div>
          </div>
        </div>

        <div class="hidden md:grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div class="rounded-lg bg-card text-card-foreground shadow-sm border-2 border-[#FF4438] relative overflow-hidden">
            <div class="absolute top-0 left-1/2 transform -translate-x-1/2 bg-[#FF4438] text-white px-4 py-1 rounded-b-lg text-sm font-medium">
              Más Popular
            </div>
            <div class="p-8 pt-12"><div class="text-center mb-8">
              <h3 class="text-2xl font-bold text-[#1D252C] mb-2">Plan Mensual</h3>
              <p class="text-gray-600 mb-6">Para restaurantes independientes, grupos y agencias</p>
              <div class="mb-4"><div class="flex items-center justify-center gap-1">
                <span class="text-5xl font-bold text-[#1D252C]">&euro; 29</span>
                <span class="text-xl text-gray-600">/mes</span>
              </div>
              <p class="text-sm text-gray-600 mt-2">Primer restaurante incluido</p>
              <p class="text-sm text-green-500 font-medium mt-1">+&euro;29/mes por cada restaurante adicional</p>
            </div>
          </div>
          <div class="space-y-4 mb-8">
            <div class="flex items-center gap-3">
              <i class="icon-checkCircle text-xl text-[#10B981]"></i>
              <span class="text-gray-700">Colaboraciones públicas ilimitadas</span>
            </div>
            <div class="flex items-center gap-3">
              <i class="icon-checkCircle text-xl text-[#10B981]"></i>
              <span class="text-gray-700">Chat ilimitado</span>
            </div>
            <div class="flex items-center gap-3">
              <i class="icon-checkCircle text-xl text-[#10B981]"></i>
              <span class="text-gray-700">Analíticas básicas</span>
            </div>
            <div class="flex items-center gap-3">
              <i class="icon-checkCircle text-xl text-[#10B981]"></i>
              <span class="text-gray-700">Gestión de múltiples restaurantes</span>
            </div>
          </div>
          <a href="/register/2" class=" text-lg inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 px-4 w-full bg-[#FF4438] hover:bg-[#FF4438]/90 text-white font-semibold py-3">
            Comenzar
          </a>
        </div>
          </div>
          <div class="rounded-lg bg-card text-card-foreground shadow-sm border-2 border-[#FDBD50] relative overflow-hidden">
          <div class="absolute top-0 left-1/2 transform -translate-x-1/2 bg-[#FDBD50] text-white px-4 py-1 rounded-b-lg text-sm font-medium">Mejor Valor</div>
          <div class="p-8 pt-12">
            <div class="text-center mb-8">
              <h3 class="text-2xl font-bold text-[#1D252C] mb-2">Pago Único</h3>
              <p class="text-gray-600 mb-6">Para restaurantes independientes, grupos y agencias</p>
              <div class="mb-4"><div class="flex items-center justify-center gap-1">
                <span class="text-5xl font-bold text-[#1D252C]">&euro; 232</span>
              </div>
              <p class="text-sm text-gray-600 mt-2">Primer restaurante incluido</p>
              <p class="text-sm text-green-500 font-medium mt-1">+&euro;232 por cada restaurante adicional</p>
            </div>
          </div>
          <div class="space-y-4 mb-8">
            <div class="flex items-center gap-3">
              <i class="icon-checkCircle text-xl text-[#10B981]"></i>
              <span class="text-gray-700">Colaboraciones públicas ilimitadas</span>
            </div>
            <div class="flex items-center gap-3">
              <i class="icon-checkCircle text-xl text-[#10B981]"></i>
              <span class="text-gray-700">Chat ilimitado</span>
            </div>
            <div class="flex items-center gap-3">
              <i class="icon-checkCircle text-xl text-[#10B981]"></i>
              <span class="text-gray-700">Analíticas básicas</span>
            </div>
            <div class="flex items-center gap-3">
              <i class="icon-checkCircle text-xl text-[#10B981]"></i>
              <span class="text-gray-700">Gestión de múltiples restaurantes</span>
            </div>
          </div>
          <a href="/register/2" class="text-lg inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 px-4 w-full bg-[#FDBD50] hover:bg-[#FDBD50]/90 text-white font-semibold py-3">
            Comenzar
          </a>
        </div>
        </div>
        </div>
      </div>
    </section>

    <section ref="faq" class="px-4 py-20 md:px-6 lg:px-8 bg-[#F9F9F9]">
      <div class="max-w-4xl mx-auto">
        <div class="text-center mb-16">
          <h2 class="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Preguntas Frecuentes</h2>
          <p class="text-xl text-gray-600">Resolvemos las dudas más comunes sobre Solofoodies</p>
        </div>
        <div class="space-y-4">
          <div v-for="faq in faqs" :key="faq.id" class="rounded-lg bg-card text-card-foreground border-0 shadow-lg">
            <div class="p-0" @click="toogleFaqs(faq.id)">
              <button class="w-full p-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors">
                <h3 class="text-lg font-semibold text-gray-900">{{ faq.title }}</h3>
                <i class="text-[#FF4438]" :class="faq.open === true ? 'icon-minus' : 'icon-pluss'"></i>
              </button>
              <div class="px-6 pb-6" v-if="faq.open === true">
                <p class="text-gray-600 leading-relaxed text-left">{{ faq.desc }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="px-4 py-20 md:px-6 lg:px-8 bg-gradient-to-r from-[#FF4438] to-[#FDBD50]">
      <div class="max-w-4xl mx-auto text-center">
        <h2 class="text-4xl md:text-4xl font-bold text-white mb-6">
          Empieza tu primera colaboración hoy
        </h2>
        <p class="text-xl text-white/90 mb-10 max-w-2xl mx-auto text-white">
          Únete a miles de restaurantes y creadores gastronómicos que ya están formando alianzas increíbles.
        </p>
        <div class="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="/register/1" class="inline-flex items-center justify-center gap-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 bg-white text-[#FF4438] hover:bg-white/10 hover:text-white hover:border-white border border-transparent px-4 sm:px-8 py-4 text-sm sm:text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 font-semibold">
            QUIERO COLABORAR COMO FOODIE
          </a>
          <a href="/register/2" class="inline-flex items-center justify-center gap-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border h-10 border-white text-[#FF4438] bg-white hover:bg-white/10 hover:text-white px-3 md:px-6 lg:px-8 py-4 text-xs md:text-sm lg:text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 font-semibold whitespace-normal leading-tight">
            SOY UN RESTAURANTE, QUIERO RECIBIR CREADORES
          </a>
        </div>
      </div>
    </section>

    <footer class="px-4 py-12 border-t border-gray-200 md:px-6 lg:px-8 bg-white">
      <div class="max-w-7xl mx-auto">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div class="col-span-2">
            <div class="flex items-center gap-2 mb-4">
              <Newlogo/>
            </div>
            <p class="text-gray-600 mb-4 max-w-md text-left">
              Conectando restaurantes y creadores de contenido gastronómico en todo el mundo a través de colaboraciones significativas.
            </p>
            <ul class="gap-4 hidden md:flex">
              <li v-for="social in socials" :key="social">
                <a class="footer_icons" :href="social.url" target="_blank" rel="noopener noreferrer">
                  <i :class="social.icon"></i>
                </a>
              </li>
            </ul>
          </div>
          <div class="hidden md:block">

          </div>
          <div class="col-span-2 md:col-span-1 text-left">
            <h4 class="font-semibold text-[#1D252C] mb-4">Plataforma</h4>
            <div class="space-y-2">
              <span class="cursor-pointer block text-gray-600 hover:text-[#FF4438] transition-colors" @click="scrollMeTo('why-us')">¿Por qué Solofoodies?</span>
              <span class="cursor-pointer block text-gray-600 hover:text-[#FF4438] transition-colors" @click="scrollMeTo('how-it-works')">¿Cómo funciona Solofoodies?</span>
              <span class="cursor-pointer block text-gray-600 hover:text-[#FF4438] transition-colors" @click="scrollMeTo('history')">Historias de exito </span>
              <span class="cursor-pointer block text-gray-600 hover:text-[#FF4438] transition-colors" @click="scrollMeTo('features')">¿Para quién es Solofoodies?</span>
              <span class="cursor-pointer block text-gray-600 hover:text-[#FF4438] transition-colors" @click="scrollMeTo('pricing')">Planes y Precios</span>
            </div>
            <ul class="flex gap-4 pt-4 md:hidden">
              <li v-for="social in socials" :key="social">
                <a class="footer_icons" :href="social.url" target="_blank" rel="noopener noreferrer">
                  <i :class="social.icon"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="pt-8 border-t border-gray-100 flex flex-col md:flex-row items-center justify-between">
          <p class="text-gray-600 mb-4 md:mb-0">© {{date}} SoloFoodies. Todos los derechos reservados.</p>
          <div class="flex items-center gap-6">
            <a href="/politics" class="text-gray-600 hover:text-[#FF4438] transition-colors text-sm">Política de Privacidad</a>
            <a href="/terms" class="text-gray-600 hover:text-[#FF4438] transition-colors text-sm">Términos de Servicio</a>
            <a href="/cookies-politics" class="text-gray-600 hover:text-[#FF4438] transition-colors text-sm">Política de Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Newlogo from '@/components/logos/solofoodies-logo'
import { URL } from '@/constants'
import axios from 'axios'
export default {
  name: 'Home',
  components: {
    Newlogo
  },
  data: () => ({
    date: new Date().getFullYear(),
    page: 1,
    colavs: 0,
    restaurants: 0,
    foodies: 0,
    cities: 0,
    faqs: [
      {
        id: 0,
        open: false,
        title: '¿Cuál es la permanencia del servicio?',
        desc: 'En Solofoodies no hay permanencia. Puedes contratar el plan mensual por 29 €/mes por restaurante y cancelarlo cuando quieras. También tienes la opción del plan único, con un solo pago de 232 € de por vida, sin suscripciones ni renovaciones.'
      },
      {
        id: 1,
        open: false,
        title: '¿Qué incluye el servicio de Solofoodies para restaurantes?',
        desc: 'Incluye todo lo que necesitas para colaborar con influencers gastronómicos: publicación de colaboraciones, recepción de solicitudes, chat integrado, sistema de valoraciones, integración con CoverManager y otros integradores de reservas y soporte continuo. Es una plataforma todo en uno para restaurantes que buscan crecer en redes sociales.'
      },
      {
        id: 2,
        open: false,
        title: '¿Puedo elegir a los creadores con los que colaboro?',
        desc: 'Sí. Cada restaurante puede ver los perfiles de los foodies interesados, revisar su contenido, sus estadísticas y decidir con quién colaborar. Solo colaboras si tú aceptas la solicitud.'
      },
      {
        id: 3,
        open: false,
        title: '¿Qué tipo de influencers/creadores puedo encontrar en Solofoodies?',
        desc: 'Contamos con una comunidad de foodies, creadores gastronómicos y microinfluencers, tanto locales como internacionales. Puedes recibir solicitudes de personas que viven en tu ciudad o que la visitarán próximamente.'
      },
      {
        id: 4,
        open: false,
        title: '¿Cómo gestiono las reservas de las colaboraciones?',
        desc: 'Si tu restaurante usa CoverManager, las reservas de los creadores gastronómicos se sincronizan automáticamente en tu sistema. Además, los detalles de cada colaboración (número de personas, tipo de contenido, requerimientos especiales) se registran para que tanto el equipo de marketing como el equipo de sala estén perfectamente coordinados. Si no utilizas CoverManager, puedes gestionar las reservas directamente dentro de Solofoodies. Una vez aceptada la colaboración, verás todos los detalles necesarios y podrás comunicar al equipo de sala manualmente para garantizar que la experiencia sea fluida y profesional. Con Solofoodies, aseguras que todas tus colaboraciones con influencers estén organizadas, sin malentendidos ni pérdida de información.'
      },
      {
        id: 5,
        open: false,
        title: '¿Puedo usar Solofoodies si tengo varios restaurantes o diferentes marcas?',
        desc: 'Sí. Si tienes varias ubicaciones del mismo restaurante, puedes gestionarlas todas desde un solo perfil por 29 €/mes. Es ideal para franquicias, cadenas o grupos con una marca común, ya que puedes publicar colaboraciones y centralizar la gestión. Si manejas restaurantes con marcas distintas, cada una requiere su propia suscripción. Por ejemplo, si gestionas tres marcas diferentes, pagarás 29 € por cada una, es decir, 87 €/mes. Puedes activar o desactivar marcas según tus necesidades, manteniendo control total sobre las colaboraciones gastronómicas activas.'
      },
      {
        id: 6,
        open: false,
        title: '¿Puedo colaborar con influencers de otros países?',
        desc: '¡Claro! Solofoodies está pensado para facilitar colaboraciones gastronómicas internacionales. Los creadores pueden indicar sus viajes futuros y tú puedes aceptar solicitudes de quienes planean visitar tu ciudad.'
      },
      {
        id: 7,
        open: false,
        title: '¿Cómo me ayuda Solofoodies a conseguir más visibilidad?',
        desc: 'Las colaboraciones con creadores generan contenido auténtico para redes sociales y permiten que tu restaurante aparezca en cuentas relevantes, tanto en Instagram como TikTok. Esto se traduce en mayor visibilidad y potencial de nuevas reservas.'
      },
      {
        id: 8,
        open: false,
        title: '¿Qué pasa después de una colaboración con un influencer?',
        desc: 'Una vez finalizada la colaboración, tanto el restaurante como el creador pueden dejar una valoración mutua. Este sistema permite construir una comunidad de confianza dentro de Solofoodies. Los restaurantes pueden valorar a los creadores según su profesionalismo, cumplimiento y calidad del contenido. Así, otros negocios pueden identificar fácilmente qué perfiles generan mejor impacto y colaboran de forma más profesional. De esta manera, Solofoodies se convierte en una herramienta no solo para conectar, sino también para elegir mejor con quién colaborar.'
      },
      {
        id: 9,
        open: false,
        title: '¿Qué diferencia a Solofoodies de contactar influencers por Instagram?',
        desc: 'En Solofoodies todo está estructurado: publicas tu oferta, recibes solicitudes, chateas, gestionas reservas y calificas. Sin DMs desordenados, sin perder tiempo. Además, accedes a una red de creadores ya interesados en colaborar con restaurantes.'
      },
      {
        id: 10,
        open: false,
        title: '¿Puedo utilizar Solofoodies si soy una agencia de marketing o gestiono varios restaurantes?',
        desc: 'Sí. Si eres una agencia de marketing gastronómico o gestionas varios restaurantes, puedes usar Solofoodies desde un único perfil. Cada restaurante con una marca distinta paga 29 €/mes, y puedes dar de alta o baja los que necesites según tu cartera de clientes. Por ejemplo, si gestionas tres marcas diferentes, pagarás 87 €/mes en total, con acceso completo a publicar colaboraciones, recibir solicitudes de creadores gastronómicos, chatear, valorar y ver métricas por restaurante. Solofoodies es ideal para grupos de restauración y agencias que buscan centralizar la gestión de sus colaboraciones con influencers de forma profesional y flexible.'
      }
    ],
    testimonials: [
      {
        img: 'MP',
        autor: 'Mike Ochoa',
        carge: 'Pawer Agency',
        body: '“Nos permite planificar contenido con creadores que viajan por España. Eso antes era imposible de gestionar manualmente.”'
      },
      {
        img: 'ER',
        autor: 'Eva Rodrigo',
        carge: 'Vayro Gestión',
        body: '"Solofoodies nos ayudó a conectar con creadores locales e internacionales en minutos, la plataforma es lo máximo"'
      },
      {
        img: 'CG',
        autor: 'Carlos Garcia',
        carge: 'La Txaska Etxea',
        body: 'Hemos ahorrado incontables horas de gestión y aumentando nuestra visibilidad gracias a Solofoodies"'
      },
      {
        img: 'MF',
        autor: 'Miguel Feijo',
        carge: 'Hatillo Madrid',
        body: '"Colaboramos con creadores cada semana sin perder tiempo en mensajes. Todo está organizado"'
      }
    ],
    socials: [
      {
        icon: 'icon-instagram',
        url: 'https://www.instagram.com/solofoodies'
      },
      {
        icon: 'icon-linkedin',
        url: 'https://www.linkedin.com/company/solofoodies/'
      },
      {
        icon: 'icon-tiktok',
        url: 'https://www.tiktok.com/@solofoodies'
      },
      {
        icon: 'icon-youtube',
        url: 'https://www.youtube.com/@solofoodies'
      },
      {
        icon: 'icon-facebook',
        url: 'https://www.facebook.com/solofoodies/'
      }
    ],
    responsiveTap: 'mensual'
  }),
  methods: {
    parseLocale (numero) {
      return numero.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    },
    scrollMeTo (refName) {
      var element = this.$refs[refName]
      var top = element.offsetTop
      console.log(top, this.$refs.theBody)
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    },
    toogleFaqs (id) {
      this.faqs.map(($0, index) => {
        $0.open = false
        return $0
      })
      this.faqs[id].open = !this.faqs[id].open
    },
    toogleResponsiveTap (value) {
      this.responsiveTap = value
    },
    getStats () {
      const route = `${URL}/home-stats`
      axios
        .get(route)
        .then(({ data }) => {
          this.colavs = this.parseLocale(data?.stats?.collaborations)
          this.restaurants = this.parseLocale(data?.stats?.restaurants)
          this.foodies = this.parseLocale(data?.stats?.foodies)
          this.cities = this.parseLocale(data?.stats?.cities)
        })
        .catch((error) => (console.log('getStats ', error)))
    }
  },
  /* unmounted () {
    window.removeEventListener('scroll', this.handleScroll)
    document.getElementById('theBody').classList.remove('pageableBody')
  }, */
  mounted () {
    this.getStats()
    /* window.addEventListener('scroll', this.handleScroll)
    document.getElementById('theBody').classList.add('pageableBody') */
  }
}
</script>

<style lang="scss" scoped>
  .footer_icons{
    background: #1d252c;
    font-size: 17px;
    display: inline-flex;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    color: white !important;
    align-items: center;
    justify-content: center;
  }
  .i24{
    font-size: 24px;
  }
  .hover\:bg-white\/10:hover {
    background-color: #ffffff1a;
    color: rgb(255, 255, 255);
  }
  .bg-gradient-to-r {
    background-image: linear-gradient(to right, #FF4438 , #FDBD50);
  }
  .bg-card {
    background-color: hsl(0, 0%, 100%);
  }
  .text-\[\#FF4438\] {
    color: #FF4438;
  }
  .text-\[\#10B981\] {
    color: #10B981;
  }
  .bg-\[\#F9F9F9\] {
    background-color: #F9F9F9;
  }
  .bg-\[\#FDBD50\] {
    background-color: #FDBD50;
  }
  .border-\[\#FDBD50\] {
    border-color: #FDBD50;
}
  .bg-\[\#FF4438\] {
    background-color: #FF4438;
  }
  .border-\[\#FF4438\] {
    border-color: #FF4438;
  }
  .hover\:bg-\[\#FF4438\]\/10:hover {
    background-color: #ff44381a;
  }
  .hover\:text-accent-foreground:hover {
    color: hsl(210, 11%, 15%);
  }
  .from-\[\#FF4438\]\/5 {
    background-image: linear-gradient(to bottom right, rgba(255, 68, 56, .05), rgba(253, 189, 80, .05));
  }
  .text-\[\#FDBD50\] {
    color: #FDBD50;
  }
  .bg-\[\#FDBD50\]\/10 {
    background-color: #fdbd501a;
  }
  .bg-\[\#10B981\]\/10 {
    background-color: #10b9811a;
  }
  .bg-\[\#FDBD50\]\/10 {
    background-color: #fdbd501a;
  }
  .text-\[\#1D252C\] {
    color: rgb(29, 37, 44);
  }
  .font-bold {
    font-weight: 700;
  }
  @media (min-width: 768px) {
    .md\:text-7xl {
      font-size: 4.5rem;
      line-height: 1;
    }
  }
  @media (min-width: 768px) {
    .md\:text-2xl {
        font-size: 1.5rem;
        line-height: 2rem;
    }
  }
  .text-gray-600 {
    color: rgb(75, 85, 99);
  }
  .bg-\[\#FF4438\]\/10 {
    background-color: #ff44381a;
  }
</style>
